import {Injectable} from "@angular/core";
import {Observable, interval } from "rxjs";

@Injectable()
export class ClockService {

  private clock: Observable<Date>;

  constructor() { 
    
    //TODO FIX
    //this.clock = Observable.interval(1000).map(tick => new Date()).share();
    this.clock = interval(1000).map(tick => new Date());
   }

  getClock(): Observable<Date> { return this.clock; }


  Convert_milliseconds_To_Hours(TimeDefined) {

    var ms = TimeDefined % 1000;
    TimeDefined = (TimeDefined - ms) / 1000;

    var seconds = TimeDefined % 60;
    TimeDefined = (TimeDefined - seconds) / 60;

    var minutes = TimeDefined % 60;

    var hours = (TimeDefined - minutes) / 60;

         
    return pad2(hours) + ':' + pad2(minutes) + ':' + pad2(seconds) //+ '.' + pad2(ms);
  }

}

// Return to 2 digits format 00:00:00.2 - Used in countdown timer  
function pad2(number) { return (number < 10 ? '0' : '') + number }